import {
    UPDATE_STATE_ARRIVAL_DEPATURE,
    RESET_STATE_ARRIVAL_DEPATURE,
} from '../../actions/refreshArrivalDepature/refreshArrivalDepatureAction';

const initialState = {
    refreshArrivalDepature: false,
};

const refreshArrivalDepature = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_STATE_ARRIVAL_DEPATURE:
            return {
                refreshArrivalDepature: true,
            };
        case RESET_STATE_ARRIVAL_DEPATURE: {
            return initialState;
        }
        default:
            return state;
    }
};

export default refreshArrivalDepature;